{
  "slug": "what-questions-are-on-an-iq-test",
  "title": "What Questions Are on an IQ Test?",
  "description": "Explore common IQ-test question types, including patterns, matrices, analogies, number sequences, memory, and spatial tasks.",
  "summary": "IQ tests use several task families to sample different cognitive abilities. A balanced assessment does not rely on one puzzle type or a single learned trick.",
  "category": "Practice questions",
  "sections": [
    {
      "heading": "Common task families",
      "paragraphs": [
        "Typical formats include matrix reasoning, pattern completion, analogies, classification, number series, spatial rotation, working-memory tasks, vocabulary, and speeded symbol work. The exact mix depends on the test.",
        "Some professional items are spoken, demonstrated, or completed with physical materials rather than shown as multiple choice."
      ]
    },
    {
      "heading": "What each format is trying to sample",
      "paragraphs": [
        "Matrices and sequences often emphasize rule discovery; analogies examine relationships; spatial tasks involve mental transformation; memory tasks require holding and manipulating information.",
        "No item type is perfectly culture-free. Language, schooling, familiarity, and interface experience can influence how efficiently a person understands and answers."
      ]
    },
    {
      "heading": "Practice without compromising meaning",
      "paragraphs": [
        "Practice general reasoning strategies and learn common instructions, but avoid seeking leaked items from protected tests. Repeated exposure to identical questions measures memory as well as reasoning.",
        "Use varied, original puzzles and review why an answer works. That builds familiarity while preserving a clearer distinction between practice and assessment."
      ]
    }
  ],
  "faqs": [
    {
      "question": "Are all IQ-test questions multiple choice?",
      "answer": "No. Professional tests may use spoken responses, constructed answers, manipulatives, or timed coding tasks."
    },
    {
      "question": "Do IQ tests include mathematics?",
      "answer": "Some use quantitative reasoning, but they usually emphasize relationships and logic rather than advanced school mathematics."
    }
  ],
  "related": [
    "20-pattern-recognition-questions",
    "matrix-reasoning-practice",
    "analogies-practice"
  ],
  "sources": [
    {
      "label": "APA Dictionary of Psychology — intelligence test",
      "url": "https://dictionary.apa.org/intelligence-test"
    },
    {
      "label": "Pearson — WAIS-5 sample score report",
      "url": "https://www.pearsonassessments.com/content/dam/school/global/clinical/us/assets/wais-5/wais-5-sample-score-report-with-demographically-referenced-scores.pdf"
    }
  ]
}
